import React from 'react'
import ChartJsChartContainer from '../../../Components/Charts/ChartJsChart'

export default function ChartJsChart() {
  
  return (
    <div className='page-body'>
        <ChartJsChartContainer/>
    </div>
  )
}
